export default __webpack_public_path__ + "static/media/spinner.868a6998.gif";